import { PropTypes } from 'react';
export const shape = PropTypes.object;
